const wifiControlUnits = [
  'lwzx80',
  'wwk',
  'temprawifi',
];

const gatewayControlUnits = [
  'wpmg r290',
];

const isModuleOfType = (
  controlUnits: string[],
  controlUnit: string, // has a value like for example VALUEDEFINITION_LWZX80
): boolean =>
  controlUnits.some((unit) =>
    controlUnit.toLowerCase()
      .endsWith(unit)
  );

export const isWifiModule = (
  controlUnit?: string,
): boolean =>
  !!controlUnit
  && isModuleOfType(wifiControlUnits, controlUnit);

export const isGatewayModule = (
  controlUnit?: string,
): boolean =>
  !!controlUnit
  && isModuleOfType(gatewayControlUnits, controlUnit);

const hiddenFromAdvancedUserControlUnits = wifiControlUnits.filter((unit) => unit !== 'wwk');

export const isHiddenFromAdvancedUser = (
  controlUnit?: string,
): boolean =>
  !!controlUnit
  && isModuleOfType(hiddenFromAdvancedUserControlUnits, controlUnit);

export const isISGModule = (
  controlUnit?: string,
): boolean =>
  !!controlUnit
  && !isWifiModule(controlUnit) && !isGatewayModule(controlUnit);
